<template>
  <formatted-text-input
    v-bind="{ label, required, requiredClass, requiredText, id, name, placeholder, error }"
    :classes="[isValid ? inputValidClass : false, classes]"
    :icon-class="isValid ? iconsValidClass : false"
    :left-icon="cardIcon"
    :left-icon-type="cardIconType"
    :right-icon="isValid ? iconValid : ''"
    :options="{ creditCard: true }"
    @input="emit">
    <slot/>
  </formatted-text-input>
</template>

<script>
import * as props from '../mixins/props'
import cardValidator from 'card-validator'
import { types as cardTypes } from 'credit-card-type'

export default {

  mixins: [
    props.classes,
    props.error,
    props.id,
    props.label,
    props.name,
    props.placeholder,
    props.required,
  ],

  props: {
    icons: {
      type: Object,
      default: () => {}
    },
    iconDefault: {
      type: String,
      default: 'credit-card',
    },
    iconValid: {
      type: String,
      default: 'check',
    },
    iconsValidClass: {
      type: String,
      default: 'has-text-success',
    },
    inputValidClass: {
      type: String,
      default: 'is-success',
    },
    acceptedTypes: {
      type: Array,
      default: () => [
        cardTypes.AMERICAN_EXPRESS,
        cardTypes.DINERS_CLUB,
        cardTypes.JCB,
        cardTypes.MAESTRO,
        cardTypes.MASTERCARD,
        cardTypes.DISCOVER,
        cardTypes.VISA,
      ]
    },
  },

  data() {
    return {
      isValid: false,
      cardType: '',
      cardIcons: { ...this.icons,
        [cardTypes.AMERICAN_EXPRESS]: 'cc-amex',
        [cardTypes.DINERS_CLUB]: 'cc-diners-club',
        [cardTypes.JCB]: 'cc-jcb',
        [cardTypes.MAESTRO]: 'cc-mastercard',
        [cardTypes.MASTERCARD]: 'cc-mastercard',
        [cardTypes.DISCOVER]: 'cc-discover',
        [cardTypes.VISA]: 'cc-visa',
      }
    }
  },

  methods: {
    emit(value) {
      let validator = cardValidator.number(value)
      this.isValid = this.acceptedTypes.includes(this.cardType) ? validator.isValid : false
      this.cardType = validator.card ? validator.card.type : false
      this.$emit('input', value)
      this.$emit('valid', this.isValid)
      validator.card && this.$emit('card', validator.card)
    },
  },

  computed: {
    cardIcon() {
      return this.cardIcons[this.cardType] || this.iconDefault
    },
    cardIconType() {
      return this.cardIcons[this.cardType] ? 'fab' : 'fas'
    }
  }
}
</script>
